


















import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'

@Component({})
export default class AppAppCard extends Vue {
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly icon!: string
  @Prop() readonly title!: string
  @Prop({ default: 0 }) readonly position!: string
  @Prop() readonly isDraggingActive!: boolean
}
